import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleLeftMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-left-medium, dropdown, caret" maskId="round-filled-radius-1-stroke-1.5-IconChevronTriangleLeftMedium"><path d="M13.1042 6.75167C13.9106 6.25684 15.0007 6.82749 15.0007 7.82296V16.1765C15.0005 17.2383 13.7602 17.8162 12.947 17.1335L7.97433 12.9568C7.37965 12.4572 7.37965 11.5422 7.97433 11.0427L12.947 6.86593L13.1042 6.75167Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleLeftMedium;
